<template>
  <div>
    <div
    ref="chartdiv"
    id="chartdiv"
          
        ></div>

        
    <TokenComponent ref="frmtoken" />
  </div>
</template>

<script>
import TokenComponent from "../components/Token";

import * as am5 from "@amcharts/amcharts5";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as am5percent from "@amcharts/amcharts5/percent";

export default {
  props: ["item", "naslov", "vino"],
  name: "WineItem",
  components: {
    TokenComponent,
  },
  data: () => ({
    // graphic_data:[],
    root: undefined,
    naslov_glob: "",
    headers: [
      { text: "Naziv", value: "category", align: "left", sortable: false },
      { text: "Vrednost", value: "value", align: "left", sortable: false },
    ],
    pagination: {
      sortBy: "value",
      rowsPerPage: 10000000,
    },
    items: [],
  }),
  computed: {},
  watch: {
    item: function (val) {
      // let self = this
      if (val !== undefined) {
        this.items = val;
        this.ucitajGrafik();
        setTimeout(() => {
          console.log(document.getElementsByClassName("am5-reader-container"))
          document.getElementsByClassName("am5-reader-container")[0].parentElement.style.height = "100%"  
        }, 300);
      }
    },
    naslov: function (val) {
      this.naslov_glob = val;
    },
    vino: function (val) {
      
    }
  },
  methods: {
    changeSort(column) {
      if (column !== "funkcije")
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false;
        }
    },
    currencyFormatDEdec(num) {
      if (num !== undefined && num !== null)
        return num
          .toFixed(2) // always two decimal digits
          .replace(".", ",") // replace decimal point character with ,
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
      // use . as a separator
      else return 0;
    },
//     ucitajGrafik: function () {
//       var root = am5.Root.new("chartdiv");

// root.setThemes([
//   am5themes_Animated.new(root)
// ]);

// var chart = root.container.children.push( 
//   am5percent.SlicedChart.new(root, {
//     layout: root.horizontalLayout
//   }) 
// );

// // Define data
// var data = [{
//   stage: "Stage #1",
//   applicants: 100
// }, {
//   stage: "Stage #2",
//   applicants: 70
// }, {
//   stage: "Stage #3",
//   applicants: 35
// }, {
//   stage: "Stage #4",
//   applicants: 10
// }];

// // Create series
// var shape = "M53.5,476c0,14,6.833,21,20.5,21s20.5-7,20.5-21V287h21v189c0,14,6.834,21,20.5,21 c13.667,0,20.5-7,20.5-21V154h10v116c0,7.334,2.5,12.667,7.5,16s10.167,3.333,15.5,0s8-8.667,8-16V145c0-13.334-4.5-23.667-13.5-31 s-21.5-11-37.5-11h-82c-15.333,0-27.833,3.333-37.5,10s-14.5,17-14.5,31v133c0,6,2.667,10.333,8,13s10.5,2.667,15.5,0s7.5-7,7.5-13 V154h10V476 M61.5,42.5c0,11.667,4.167,21.667,12.5,30S92.333,85,104,85s21.667-4.167,30-12.5S146.5,54,146.5,42 c0-11.335-4.167-21.168-12.5-29.5C125.667,4.167,115.667,0,104,0S82.333,4.167,74,12.5S61.5,30.833,61.5,42.5z";

// var series = chart.series.push(
//   am5percent.PictorialStackedSeries.new(root, {
//     name: "Series",
//     categoryField: "stage",
//     valueField: "applicants",
//     orientation: "vertical",
//     svgPath: shape
//   })
// );

// series.data.setAll(data);

// series.labels.template.set("visible", false);
      
//     },
    ucitajGrafik: function () {
      let root; // = am5.Root.new(this.$refs.chartdiv);

      

      if (this.root !== undefined) {
        root = this.root;
        root.container.children.clear();
      } else {
        root = am5.Root.new(this.$refs.chartdiv);

        this.root = root;
      }
      
      

      // root.setThemes([am5themes_Animated.new(root)]);

      // Create chart
      // https://www.amcharts.com/docs/v5/charts/percent-charts/sliced-chart/
      var chart = root.container.children.push(
        
        am5percent.SlicedChart.new(root, {
          layout: root.horizontalLayout
        })
      );

      // Create series
      // https://www.amcharts.com/docs/v5/charts/percent-charts/sliced-chart/#Series


      
      
      var series = chart.series.push(
        am5percent.PictorialStackedSeries.new(root, {
          alignLabels: true,
          orientation: "vertical",
          valueField: "value",
          categoryField: "category",
          paddingLeft: 0,
          svgPath:
           this.vino ? "m -456.75078,323.94077 c 0,-4.7 -1,-9.3 -2.6,-13.7 -0.9,-2.5 -2,-4.9 -2.9,-7.4 -1.5,-4.1 -2.3,-8.4 -2.5,-12.9 0,-0.8 0,-1.6 -0.1,-2.5 v 0.1 c -0.1,-2.3 -0.1,-4.6 -0.1,-6.8 0,-0.8 0,-1.7 0,-2.5 0,0 0,-0.1 0,-0.3 0,-0.4 0.2,-0.7 0.3,-1.1 0,-0.2 0.1,-0.3 0.1,-0.5 0,-0.5 0,-1 0,-1.5 0,-0.3 -0.2,-0.6 -0.3,-1 -0.1,-0.2 -0.1,-0.5 -0.1,-0.7 0,-0.4 -0.2,-0.6 -0.5,-0.7 -0.4,-0.1 -1,-0.2 -1.4,-0.2 -1.7,0 -2.5,0 -4.1,0 -0.4,0 -0.7,0.1 -1.1,0.2 -0.4,0.1 -0.6,0.3 -0.5,0.7 0,0.2 0,0.5 -0.1,0.7 -0.1,0.3 -0.2,0.6 -0.3,1 0,0.5 0,1 0,1.5 0,0.2 0.1,0.3 0.1,0.5 0.1,0.4 0.3,0.8 0.3,1.2 0,3.2 -0.1,6.3 -0.2,9.5 0,0.3 0,1.2 0,1.6 -0.1,1.3 -0.2,2.7 -0.3,4 -0.6,4.8 -1.9,9.4 -3.9,13.8 -2.7,5.9 -4,12 -4,18.4 0,7.6 0,15.3 0,22.9 0,1.8 0.1,3.6 0.2,5.4 0.1,1.5 0.8,2.3 2.2,2.6 0.3,0.1 0.7,0.1 1,0.2 4.4,0.6 8.7,0.8 13.1,0.5 1.8,-0.1 3.6,-0.4 5.4,-0.6 1.3,-0.2 2,-0.9 2.2,-2.3 0.2,-1.2 0.3,-2.4 0.3,-3.6 -0.1,-8.7 -0.1,-17.6 -0.2,-26.5 z" :
                       "m 198.70189,24.389804 c -0.64075,0.0178 -1.2814,0.09408 -1.91604,0.175707 -0.72007,0.115329 -1.42918,0.304385 -2.11924,0.539073 -0.24731,0.163489 -0.52918,0.307884 -0.76498,0.505606 -0.41777,0.353262 -0.80586,0.741034 -1.1678,1.15106 -0.3074,0.354196 -0.55655,0.751642 -0.7853,1.159427 -0.10102,0.232715 -0.22829,0.468378 -0.33229,0.71 0.0269,0.523668 0.0375,1.061673 0.0239,1.622003 -0.0114,0.47131 -0.0313,0.942661 -0.049,1.414023 4.44277,17.927986 16.08277,35.817177 37.86067,54.65085 -7.3479,3.601006 -13.67015,8.887206 -18.39305,15.486117 -8.8779,-12.445828 -23.35812,-20.62226 -39.82692,-20.62226 -27.0917,0 -49.04496,21.95787 -49.04496,49.04257 0,6.0339 1.23381,11.75161 3.24281,17.08661 -24.2408,2.986 -43.070923,23.40603 -43.070923,48.44373 0,24.5688 18.128353,44.73708 41.695153,48.30508 -3.469,6.7289 -5.61904,14.25277 -5.61904,22.34467 0,26.5027 21.05161,47.95306 47.33331,48.86806 -2.396,5.7969 -3.75081,12.11764 -3.75081,18.77554 0,27.0848 21.94868,49.04616 49.04138,49.04616 0.74,0 1.42732,-0.18713 2.15032,-0.22113 -1.269,4.35 -2.15032,8.85023 -2.15032,13.60713 0,27.0848 21.94987,49.04257 49.04257,49.04257 27.0937,0 49.04615,-21.95777 49.04615,-49.04257 0,-9.8799 -2.97907,-19.05015 -8.01797,-26.76005 21.7028,-5.061 37.89294,-24.41507 37.89294,-47.64887 0,-9.4859 -2.81924,-18.26836 -7.46814,-25.77036 19.5698,-6.4289 33.80507,-24.64765 33.80507,-46.38545 0,-1.9789 -0.35411,-3.85862 -0.58211,-5.77562 23.9398,-3.2489 42.45416,-23.55197 42.45416,-48.38277 0,-22.4558 -15.18881,-41.19434 -35.79761,-46.99624 2.346,-5.7179 3.68387,-11.972 3.68387,-18.5329 0,-27.0848 -21.95326,-49.042574 -49.04496,-49.042574 -15.1839,0 -28.59071,7.048548 -37.57261,17.881474 -7.0649,-8.491922 -16.75523,-14.683922 -28.00913,-16.904925 -5.30671,-5.022526 -10.98153,-11.247297 -16.28577,-18.146827 -0.58635,-0.579577 -1.10482,-1.212825 -1.56223,-1.900504 -0.4246,-0.624763 -0.82517,-1.264815 -1.18334,-1.930387 -0.19786,-0.362858 -0.39008,-0.730074 -0.62872,-1.068585 -0.2483,-0.32629 -0.5255,-0.612886 -0.82474,-0.90005 -0.37964,-0.410701 -0.76949,-0.812925 -1.12477,-1.245488 -0.31257,-0.39377 -0.63466,-0.779712 -0.92993,-1.186918 -0.27567,-0.388424 -0.55412,-0.775392 -0.80084,-1.183333 -0.2528,-0.400233 -0.50723,-0.799969 -0.75064,-1.206043 -0.2088,-0.369544 -0.40825,-0.744292 -0.59884,-1.123569 -0.12627,-0.231139 -0.25082,-0.463089 -0.38488,-0.68968 -0.25929,-0.412235 -0.50718,-0.83169 -0.7351,-1.262221 -0.25274,-0.534244 -0.48529,-1.078291 -0.64665,-1.648299 -0.0219,-0.109932 -0.0381,-0.219166 -0.0574,-0.328704 -2.37535,-4.479543 -4.10935,-8.620143 -5.3489,-12.53496 -0.0633,-0.07901 -0.12964,-0.155421 -0.19483,-0.233081 -0.0152,-0.01716 -0.0302,-0.03424 -0.0454,-0.0514 -0.31191,-0.352962 -0.5339,-0.704112 -0.67773,-1.042289 -0.0743,-0.06068 -0.14795,-0.114464 -0.22232,-0.178098 -0.80515,-0.688917 -1.52466,-1.467677 -2.26387,-2.224426 -0.72154,-0.682777 -1.40648,-1.403442 -2.16466,-2.046329 -0.53446,-0.369022 -1.13442,-0.641819 -1.71046,-0.944276 -0.81935,-0.439796 -1.68455,-0.778438 -2.55671,-1.096077 -1.18726,-0.488418 -2.4032,-0.885966 -3.63845,-1.231144 -1.34707,-0.377808 -2.71471,-0.669428 -4.08788,-0.933518 -1.38893,-0.262062 -2.78582,-0.477968 -4.1847,-0.678923 -1.30687,-0.181718 -2.61892,-0.328288 -3.93129,-0.46377 -1.20104,-0.113523 -2.40166,-0.238322 -3.60737,-0.28926 -0.21336,-0.0091 -0.42709,-0.0095 -0.64068,-0.0036 z"
        })
      );

      series.labelsContainer.set("width", 250);
      series.ticks.template.set("location", 0.7);

      
      series.data.setAll(this.items);

      series.labels.template.set("text", "{category}: [bold]{valuePercentTotal.formatNumber('0.00')}%[/] ({value.formatNumber('0.00')} RSD)");

      series.appear(1000);

      // root.autoResize = false;
      
      // Play initial series animation
      // https://www.amcharts.com/docs/v5/concepts/animations/#Animation_of_series
      chart.appear(2000, 500);
      
      document.getElementById("chartdiv").style.display = 'none'
      setTimeout(() => {
      document.getElementById("chartdiv").style.display = 'block'
    }, 500);
      }
  },
  mounted() {
    
  },
};
</script>
    
<style lang="scss" scoped>

.parent {
  display: flex;
  flex-wrap: wrap;
  gap: 1;
}

.child {
  flex: 0 0 100%;
}


#chartdiv {
  display: none;
  width: 100%;
  height: 700px;
}
</style>
